export { default as IngresosAlmacen } from "./IngresosAlmacen";
